import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Header from "../utils/Header";
import Swal from 'sweetalert2';
import Footer from "../utils/Footer";
import Maps2 from "../utils/Maps2.js";
import Searcher2 from "../utils/Searcher2";
import { useSearch } from "../../context/SearchContext";
import habitacion from "../../assets/Habitacion.png"
import huespedes from "../../assets/Huesped.png"
import iconLetoh from "../../assets/iconLetoh.png"
import Cancelar from "../../assets/Cancelar.png";

const ListingsGrid = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loadingImg, setLoadingImg] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentListings, setCurrentListings] = useState([]);

  const { handleSearch } = useSearch();
  const { searchResults, loading, setLoading } = useSearch()
  const city = searchParams.get("city");
  const [markers, setMarkers] = useState([])

  const checkIn = searchParams.get("checkIn");
  const checkOut = searchParams.get("checkOut");
  const guests = searchParams.get("guests");
  const tag = searchParams.get("tag");

  const itemsPerPage = 8;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalPages = Math.ceil(searchResults.length / itemsPerPage);

  const handleRedirect = (listingId) => {
    // if (!checkIn || !checkOut) {
    //   Swal.fire({
    //     imageUrl: Cancelar,
    //     imageWidth: 80,
    //     imageHeight: 80,
    //     title: 'Fechas requeridas',
    //     text: 'Por favor, selecciona las fechas de tu estadía y verifica la disponibilidad',
    //     timer: 5000,
    //     timerProgressBar: true,
    //     showConfirmButton: true,
    //     confirmButtonText: 'Entendido',
    //     confirmButtonColor: '#1F4F51',
    //     customClass: {
    //       confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

    //     },
    //   });
    //   return false;
    // }
    navigate(`/listings/${listingId}?city=${encodeURIComponent(city)}&checkIn=${encodeURIComponent(checkIn)}&checkOut=${encodeURIComponent(checkOut)}&guests=${encodeURIComponent(guests)}`);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleImageLoading = (isLoading) => {
    setLoadingImg(isLoading);
    setLoading(isLoading);
  };

  useEffect(() => {
    try {
      setLoading(true)
      setCurrentListings(searchResults.slice(indexOfFirstItem, indexOfLastItem))
      setCurrentPage(1)
      setMarkers(
        searchResults.map(
          listing => (
            {
              listingId: listing.id,
              lat: listing.lat,
              lng: listing.lng,
              label: listing.city,
              name: listing.name,
              city: listing.city,
              image: listing.listingImages[0]?.url
            }
          )
        )
      )
    }
    catch {
      setLoading(true)
    } finally {
      setLoading(false)

    }
  }, [searchResults])


  useEffect(() => {
    setCurrentListings(searchResults.slice(indexOfFirstItem, indexOfLastItem))
  }, [currentPage])

  useEffect(() => {

    const params = {
      city,
      guests,
      tag,
      checkIn,
      checkOut
    }
    handleSearch(params)
    setCurrentPage(1)
  }, [])

  return (
    <div>

      <Header />
      <Searcher2 />
      

      {/* <Maps2 lat={searchResults[0]?.lat} lng={searchResults[0]?.lng} listing=""/> */}


      {(loading || loadingImg) && (<div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
        <img src={iconLetoh} alt="Icono Letoh" className="w-20 h-20 mb-4 animate-pulse" />
      </div>)}
      {currentListings.length === 0 ? (
        <p className="text-center text-gray-500 mt-4">No hay alojamientos disponibles.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-4">
          {currentListings.map((listing, index) => (
            <div key={index} className="border rounded-lg shadow-md overflow-hidden">
              <Swiper
                modules={[Navigation]}
                navigation
                loop
                className="w-full h-48"
              >
                {listing.listingImages?.length > 0 ? (
                  listing.listingImages.map((image, imgIndex) => (
                    <SwiperSlide key={imgIndex}>
                      <img
                        src={image.url}
                        alt={`Imagen ${imgIndex + 1}`}
                        className="w-full h-48 object-cover"
                        onLoad={() => handleImageLoading(false)}
                        onError={() => handleImageLoading(false)}
                        onLoadStart={() => handleImageLoading(true)}
                      />
                    </SwiperSlide>
                  ))
                )
                  : (
                    <SwiperSlide>
                      <img
                        src="https://via.placeholder.com/300"
                        alt="Imagen no disponible"
                        className="w-full h-48 object-cover"
                        onLoad={() => handleImageLoading(false)}
                        onError={() => handleImageLoading(false)}
                        onLoadStart={() => handleImageLoading(true)}
                      />
                    </SwiperSlide>
                  )

                }
              </Swiper>

              <div className="p-4">
                <h2 className="text-lg text-primaryP font-semibold">{listing.name}</h2>
                <p className="text-gray-500">{listing.city}</p>
                {/* <p className="text-gray-600">{listing.beds} camas · {listing.guests} huéspedes</p> */}
                <p className="text-gray-500 text-sm">
                  {listing.description?.length > 150 ?
                    `${listing.description.slice(0, 150)}...` :
                    listing.description || "Descripción no disponible"
                  }</p>
                <div className="flex justify-between mt-2 text-primaryP">
                  <p className="font-bold">
                    {listing.currencyCode}
                    ${listing.price.toLocaleString('es-CO')} <span >/ noche</span>
                  </p>

                  <div className="flex gap-1">
                    <span>{listing.bedroomsNumber}</span>
                    <img src={habitacion} alt="Habitación" className="w-5 h-5" title="Habitaciones" />

                    <span className="text-gray-400">|</span>

                    <span>{listing.personCapacity}</span>
                    <img src={huespedes} alt="Huéspedes" className="w-5 h-5" title="Capacidad" />
                  </div>
                </div>

                <button
                  onClick={() => handleRedirect(listing.id, searchParams)}
                  className="bg-[#1F4F51] w-40 h-[45px] text-white font-bold rounded-md  hover:bg-[#17403F] transition mt-4"
                >
                  Reservar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="w-full overflow-x-auto">
        <div className="flex flex-wrap justify-center mt-4 gap-2">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              className={`px-4 py-2 rounded-md ${currentPage === i + 1
                ? "bg-[#1F4F51] text-white"
                : "bg-gray-200 text-gray-600"
                }`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>
{markers.length > 0 ? (
        <Maps2
          lat={markers[0]?.lat}
          lng={markers[0]?.lng}
          key={markers.length} // mejor usar markers.length que searchResults.length
          listings={markers}
          checkIn={checkIn}
          checkOut={checkOut}
          guests={guests}
        />
      ) : null}
      <Footer />
    </div>
  );
};

export default ListingsGrid;
